export { default as setTextColorByStatus } from './set-text-color-by-status';
export {
  HIGH_STATUS_COLOR,
  MEDIUM_STATUS_COLOR,
  NORMAL_STATUS_COLOR,
} from './set-text-color-by-status.constants';
